(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-content"]) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-soon-photos]');
    if (!track) return;
    var middle = track.children[1];
    if (!middle) return;

    // Rests centered on the middle photo on load instead of scrolled all the way to the first
    // card — matches where scroll-snap-align:center would land once the visitor scrolls anyway,
    // so the initial state doesn't read as "stuck" at the wrong end of the track. A no-op once
    // all three fit on screen at once (desktop) since there's nothing to scroll.
    function centerMiddle() {
      track.scrollLeft = middle.offsetLeft - (track.clientWidth - middle.clientWidth) / 2;
    }

    centerMiddle();
    window.addEventListener('resize', centerMiddle);
  })();

  (function () {
    var note = document.querySelector('[data-soon-local-time]');
    if (!note) return;
    var launch = new Date(note.getAttribute('data-soon-local-time'));
    if (isNaN(launch.getTime())) return;

    // Shows the launch time in the visitor's own time zone, but only when it isn't the same clock
    // time as Central European Time (the zone the heading already states).
    try {
      var format = { hour: 'numeric', minute: '2-digit' };
      var local = launch.toLocaleTimeString([], format);
      var central = launch.toLocaleTimeString([], Object.assign({ timeZone: 'Europe/Paris' }, format));
      if (local === central) return;
      note.textContent = "That's " + local + ' in your time zone';
      note.hidden = false;
    } catch (e) {}
  })();

  (function () {
    var input = document.querySelector('[data-soon-password]');
    if (!input) return;

    // Scrolls the field into view once it's focused, so the on-screen keyboard covering the
    // bottom half of the viewport can't hide it behind itself. Waits for the *keyboard's* resize
    // (window.visualViewport fires 'resize' once it has finished animating in) rather than a
    // guessed timeout; falls back to a fixed delay where visualViewport isn't supported.
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function scrollFieldIntoView() {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    input.addEventListener('focus', function () {
      if (!mobileQuery.matches) return;
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scrollFieldIntoView, { once: true });
      } else {
        setTimeout(scrollFieldIntoView, 300);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  (function () {
    var brandText = document.querySelector('[data-password-brand-text]');
    if (!brandText) return;

    // Same reveal header.js drives on the homepage (measure natural width, collapse to 0, then
    // expand + add is-revealed so the CSS transitions above play) — just triggered once on load
    // and never folded back, since this page has no menu toggle to bring it back with later.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      brandText.style.maxWidth = 'none';
      brandText.classList.add('is-revealed');
      return;
    }

    function reveal() {
      var naturalWidth = brandText.scrollWidth;
      brandText.style.maxWidth = '0px';

      setTimeout(function () {
        brandText.style.maxWidth = naturalWidth + 'px';
        brandText.classList.add('is-revealed');
      }, 300);
    }

    // Measuring before the custom webfont (Quattrocento Sans, loaded via the font_face calls in
    // layout/password.liquid) has actually swapped in captures the FALLBACK font's narrower
    // width — the max-width this reveals to then permanently under-shoots the text's real
    // rendered width once the real font loads a moment later, clipping "COWALKIES" for good with
    // no later re-measure to fix it (unlike header.js's own copy of this pattern, which at least
    // gets a second chance on window resize). This is why it only clipped "sometimes" — purely a
    // matter of how fast the font happened to load relative to this script running.
    // document.fonts.ready resolves once every font face is loaded and applied, so wait for it
    // (falling back to measuring immediately on older browsers without the Font Loading API).
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reveal);
    } else {
      reveal();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
